import {
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  SearchInput,
  SingleDateFilter,
} from 'framework/list';
import { useComplianceReportService } from 'domain/shared/compliance';
import { EmployeePositionFilter, OfficeFilterById } from 'domain/shared/employee';
import ComplianceReportDownloadButton from './ComplianceReportDownloadButton';
import ComplianceListForm from './ComplianceListForm';
import { useDateService } from 'framework/utils';
import ComplianceDocumentDropdownFilter from '../filter/ComplianceDocumentDropdownFilter';
import { mergeComplianceReportFilter } from './complianceReportFilters';

const ComplianceReportListPage = () => {
  const { getToday, formatDateForAPI } = useDateService();
  const { search } = useComplianceReportService();

  const filters = (
    <Filters>
      <FiltersLayout>
        <EmployeePositionFilter source="positionId" label="Position" />
        <OfficeFilterById source="officeId" label="Office" />
        <ComplianceDocumentDropdownFilter source="specification:policyTypeInPath" label="Document name" />
        <SingleDateFilter source="asOfDate" label="As of Date" />
      </FiltersLayout>
    </Filters>
  );
  return (
    <List
      getDataMethod={params =>
        search({
          ...params,
          filter: mergeComplianceReportFilter(params.filter),
        })
      }
      defaultFilter={{
        asOfDate: {
          eq: formatDateForAPI(getToday()),
        },
      }}
    >
      <ListPageLayout
        filter={filters}
        header={<ListHeader label="Compliance Report" />}
        search={<SearchInput label="worker" />}
        actions={[<ComplianceReportDownloadButton />]}
      >
        <ComplianceListForm />
      </ListPageLayout>
    </List>
  );
};

export default ComplianceReportListPage;
